module.exports = __webpack_public_path__ + "img/icon_map_5_off_001.9190e2fd.png";